/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import useAppTheme from "../../../hooks/useAppTheme";
import ROUTE_PATHS from "../../../routes/routesPath";
import {LinkGroup} from "../../../styles/styledComponent";
import CustomLogo from "../../../assets/CustomLogo.js";
import LoyaltyIcon from "../../../assets/loyaltyIcon.js";
import OfferIcon from "../../../assets/offerIcon.js";
import CollectionsIcon from "../../../assets/collectionsIcon.js";
import ProfileIcon from "../../../assets/profileIcon.js";
import {Box} from "@mui/system";
import _, {get} from "lodash";
import {toast} from "react-hot-toast";
import {getInvoiceToken} from "../../../service/invoice";
import useAppConfig from "../../../hooks/useAppConfig";
import useAuth from "../../../hooks/useAuth";

export const isProfileSurveyEnabled = (pwaConfig) => {
    return get(pwaConfig, 'appConfig.config.profileSurvey.enabled', "false").toLowerCase() === "true"
}


export const isCustomProfileSurveyEnabled = (pwaConfig) => {
  return (
    get(
      pwaConfig,
      "appConfig.config.customSurvey.enabled",
      "false",
    ).toLowerCase() === "true"
  );
};

export const customSurveyTitle = (pwaConfig) => {
  return get(
    pwaConfig,
    "appConfig.config.customSurvey.title",
    "Complete Profile",
  );
};

export const onCustomProfileSurveyClickRedirect = async (
  pwaConfig,
  decodedData,
) => {
  try {
    const link = get(
      pwaConfig,
      "appConfig.config.customSurvey.link",
      undefined,
    );
    console.log("came here inside redirect", link, pwaConfig);
    if (!link) {
      toast.error("Custom Survey missing");
    }
    const payload = {
      tenant: _.get(decodedData, "user.tenantId"),
      customerMobileNo: _.get(decodedData, "user.mobile"),
      businessUnitId: _.get(pwaConfig, "appConfig.selecteBussines.id"),
    };
    const data = await getInvoiceToken(payload);
    const linkTag = document.createElement("a");
    linkTag.target = "_blank";
    linkTag.href = `${link}${Object.values(data)[0]}`;
    return linkTag.click();
  } catch (err) {
    console.log("err", err);
  }
};

export const onProfileClickRedirect = async (pwaConfig, decodedData) => {
  try {
        const link = get(pwaConfig, 'appConfig.config.profileSurvey.link', undefined)
        console.log("came here inside redirect", link, pwaConfig)
    if (!link) {
            toast.error("Profile Survey missing")
    }
    const payload = {
            tenant: _.get(decodedData, 'user.tenantId'),
            customerMobileNo: _.get(decodedData, 'user.mobile'),
            businessUnitId: _.get(pwaConfig, 'appConfig.selecteBussines.id')
        }
        const data = await getInvoiceToken(payload)
        const linkTag = document.createElement('a')
        linkTag.target = '_blank'
        linkTag.href = `${link}${
            Object.values(data)[0]
        }`
        return linkTag.click()
  } catch (err) {
        console.log('err', err)
  }
}

const ListOfLinks = ({
  links,
  component: Component = Link,
  onLinkClick,
  end = false,
  isMobileView,
}) => {
  const [menuval, setMenuval] = useState([]);
    const {theme} = useAppTheme();
  const pwaConfig = useAppConfig();
    const decodedData = useAuth()
  let pathname = window.location.pathname;

  function setLink(navRoutes) {
    return Object.entries(links)
      .map(([key, val]) => {
            const path = (val.module === 'HTML') ? `${navRoutes[val.module]}/${key}` : navRoutes[val.module];
      return {
        ...val,
        module: path,
      };
      })
      .filter(({ module }) => !!module);
  }

  useEffect(() => {
    let navRoutes = {
      OFFER: `${ROUTE_PATHS.OFFERS}/${ROUTE_PATHS.AVAILABLE_OFFERS}`,
      HOME: `${ROUTE_PATHS.HOME}`,
      REFER_A_FRIEND: `${ROUTE_PATHS.REFER_FRIEND_PWA}`,
      LOYALTY_DETAILS: `${ROUTE_PATHS.LOYALTY_INFO}`,
      TRANSACTION_HISTORY: `${ROUTE_PATHS.TRANSACTION_HISTORY}`,
            HTML: '/html',
      TERMS_AND_CONDITIONS: `${ROUTE_PATHS.TERMS_AND_CONDITIONS}`,
            MY_PROFILE:`${ROUTE_PATHS.HOME}`,
            TICKET_DESK:`${ROUTE_PATHS.TICKET_DESK}`,
            SCHEME_MANAGEMENT:`${ROUTE_PATHS.SCHEME}`
    };

    const menus = async () => {
            const flipbook = get(pwaConfig, 'appConfig.config.flipbook', {})
            if (get(flipbook, 'enabled') === 'true'){
                const link = get(flipbook, 'link')
        const payload = {
                    tenant: _.get(decodedData, 'user.tenantId'),
                    contactNumber: _.get(decodedData, 'user.mobile')
                }
                const data = await getInvoiceToken(payload)
        const token = Object.values(data)[0];
                if (link){
                    navRoutes = {...navRoutes, FLIPBOOK: `${link}&dataToken=${token}`}
        }
      }
            const promise = await Promise.all(
                setLink(navRoutes)
            );
      setMenuval(promise);
    };
    menus();
  }, [links]);
  const avatarTextColor = pwaConfig.appConfig.config.palette.sideNav.background;
    const avatarBackgroundColor = pwaConfig.appConfig.config.palette.sideNav.textColor;


  return (
        <LinkGroup sx={{m: 4}} color="black">
      {menuval &&
                menuval.map(({name, module}) => (
          <li key={module + name}>
                            <Component onClick={onLinkClick} to={module} end={end} target={(name === 'Curated For You') ? '_blank' : '_self'}>
              {isMobileView ? (
                <Box className="display">
                  {name === "Offer for You" ? (
                                           <OfferIcon textColor={avatarTextColor} backgroundColor={avatarBackgroundColor}/>
                  ) : name === "My Profile" ? (
                                            <ProfileIcon textColor={avatarTextColor} backgroundColor={avatarBackgroundColor}/>
                  ) : name === "Loyalty Details" ? (
                                            <LoyaltyIcon textColor={avatarTextColor} backgroundColor={avatarBackgroundColor} />
                  ) : name === "Curated For You" ? (
                                            <CollectionsIcon  className="margin" textColor={avatarTextColor} backgroundColor={avatarBackgroundColor} />                                                    
                                        )  : (
                                            <CustomLogo text={name.substring(0, 1)} backgroundColor={avatarBackgroundColor} textColor={avatarTextColor} />
                  )}
                  <span
                    style={{
                      fontWeight: `${pathname === module ? 900 : 500}`,
                      color: theme.palette.text.secondary,
                      marginLeft: 5,
                                                fontFamily: theme.typography.fontFamily
                    }}
                  >
                    {name}
                  </span>
                </Box>
              ) : (
                <span
                  style={{
                    fontWeight: `${pathname === module ? 900 : 500}`,
                    color: theme.palette.primary.main,
                                            fontFamily: theme.typography.fontFamily
                  }}
                >
                  {name}
                </span>
              )}
            </Component>
          </li>
        ))}
    </LinkGroup>
  );
};

export default ListOfLinks;


